import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78f21cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basic-modal-container" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "content-wrapper" }
const _hoisted_5 = { class: "slot-content" }
const _hoisted_6 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "lock-scroll": false,
    style: {"z-index":"99999"}
  }, {
    default: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createVNode(_component_Image, {
            src: 'svg/ic_cancel_light',
            extension: "svg",
            class: "cancel-icon",
            onClick: ($event: any) => (_ctx.onClose(close))
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", {
            class: _normalizeClass(`content ${_ctx.contentAlign}`)
          }, _toDisplayString(_ctx.content), 3),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.type === _ctx.BASIC_MODAL.REMOVE)
            ? (_openBlock(), _createBlock(_component_BasicButton, {
                key: 0,
                "is-critical": "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.remove')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_BasicButton, {
            "color-type": _ctx.closeButtonColorType,
            onClick: ($event: any) => (_ctx.onClose(close))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.customButtonText || _ctx.closeButtonTextCode), 1)
            ]),
            _: 2
          }, 1032, ["color-type", "onClick"]),
          (_ctx.type === _ctx.BASIC_MODAL.CONFIRM)
            ? (_openBlock(), _createBlock(_component_BasicButton, {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.confirmButtonText || _ctx.$t('common.ok')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }))
}